import Popup from "@/layouts/popup/popup-layout.vue";
import MultiPopup from "@/layouts/popup/multi-popup-layout.vue";
import { h, createApp } from "vue";
import { customComponentPlugin } from "@/utils/global-component";
import router from '@/router';  // 기존의 router 가져오기
import { pinia } from '@/main';
import MainPopup from "@/components/main-popup.vue";
import vByteMax from '@/directives/v-byte-max';

const show = (contentComponent, popupOpts, props, emits) => {
    /*
    * contentComponent: 팝업 컴포넌트
    *
    * popupOpts
    *  - header: 팝업헤더명
    *  - contentStyle: 팝업 style
    *
    * 선택값
    * props: 팝업 컴포넌트에서 사용할 prop
    * emits: 팝업 컴포넌트에서 사용할 emit
    */

    if (!contentComponent) {
        console.log('팝업 컴포넌트는 필수값입니다.');
        return false;
    }

    if (emits && Object.hasOwn(emits, 'close')) {
        console.log('close는 사용 불가');
        return false;
    }

    let closeFunc = null;
    const close = () => {
        closeFunc();
    }

    const popupLayoutPropEmitData = {
        popupOpts,
        onClose: close
    };

    const slotPropEmitData = { ...props };
    for (const key in emits) {  //emit인 경우 on + 첫글자 대문자로 변경
        if (Object.hasOwn(emits, key)) {
            const newKey = 'on' + key.charAt(0).toUpperCase() + key.slice(1);
            slotPropEmitData[newKey] = emits[key];
        }
    }

    //팝업 닫기 emit으로 넣어줌
    slotPropEmitData.onClose = close;

    const app = createApp({
        render: () => h(Popup, popupLayoutPropEmitData, {
            default: () => h(contentComponent, slotPropEmitData)
        })
    });

    app
      .use(pinia)
      .use(router)
      .use(customComponentPlugin)
      .directive('byte-max', vByteMax);

    const el = document.createElement('div');
    document.body.appendChild(el);
    app.mount(el);

    closeFunc = () => {
        app.unmount(el);
        document.body.removeChild(el);
    };
}

const multiShow = (popupOpts, props, emits) => {
    /*
    * popupOpts
    *  - header: 팝업헤더명
    *  - contentStyle: 팝업 style
    *
    * 선택값
    * props: 팝업 컴포넌트에서 사용할 prop
    * emits: 팝업 컴포넌트에서 사용할 emit
    */

    if (emits && Object.hasOwn(emits, 'close')) {
        console.log('close는 사용 불가');
        return false;
    }

    const elId = `popup_${props.ppup.ppupSn}`;
    if (document.getElementById(elId)) {
        return;
    }

    let closeFunc = null;
    const close = () => {
        closeFunc();
    }

    const popupLayoutPropEmitData = {
        popupOpts,
        onClose: close
    };

    const slotPropEmitData = { ...props };
    for (const key in emits) {  //emit인 경우 on + 첫글자 대문자로 변경
        if (Object.hasOwn(emits, key)) {
            const newKey = 'on' + key.charAt(0).toUpperCase() + key.slice(1);
            slotPropEmitData[newKey] = emits[key];
        }
    }

    //팝업 닫기 emit으로 넣어줌
    slotPropEmitData.onClose = close;

    const app = createApp({
        render: () => h(MultiPopup, popupLayoutPropEmitData, {
            default: () => h(MainPopup, slotPropEmitData)
        })
    });

    app
        .use(pinia)
        .use(router)
        .use(customComponentPlugin);

    const el = document.createElement('div');
    el.id = elId;
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '0';
    el.style.zIndex = popupOpts.zIndex;
    document.body.appendChild(el);
    app.mount(el);

    closeFunc = () => {
        app.unmount(el);
        document.body.removeChild(el);
    };
}

const usePopup = () => {
    return {show, multiShow};
}

export { usePopup };
